import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DialerService } from '@app/_core/services/dialer.service'; 
@Injectable({
  providedIn: 'root',
})
export class LoaderService {
    constructor(private dialerService: DialerService) {}
  public status: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public onDemandLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    display(value: boolean) {
        if (!this.dialerService.getIsBlockLoader()) {
            //console.log('loaderr value' + value);
            this.status.next(value);
        }
  }

  setOnDemandLoading(value){
    this.onDemandLoading.next(value);
  }
}
